<template>
    <div class="export-lsp-content">
        <TotemButton color="dark-orange" :label="$t('ExportCourse.title')" class="export-lsp-content__button" @click="openExportLSPModal">
            <img src="@/assets/images/icons/file-export.svg" alt="Export course" class="export-lsp-content__icon" />
        </TotemButton>
        <ModalExportLSPContent :course="course" />
    </div>
</template>

<script>
import ModalExportLSPContent  from 'components/shared/modals/ModalExportLSPContent'
import { mapGetters } from 'vuex'
    export default {
        name: 'export-lsp-content',
        components: {
            ModalExportLSPContent
        },
        props: {
            course: Object
        },
        data () {
            return {
                type: 'info'
            }
        },
        computed: {
            ...mapGetters({
                lspExportErrors: 'Courses/getLspExportErrors'
            })
        },
        methods: {
            openExportLSPModal () {
                this.$modal.show('export-lsp-content')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .export-lsp-content {
        &__button {
            white-space: nowrap;
            margin: 0 30px 0 20px;
        }

        &__icon {
            margin: 0 10px 0 0;
        }

        &__toast-message {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
    }
</style>
